import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { JsonlogicExpressionEditorComponent } from './jsonlogic-expression-editor.component';
import { JsonlogicComponent } from './jsonlogic/jsonlogic.component';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    JsonlogicExpressionEditorComponent,
    JsonlogicComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    NgSelectModule,
    CardModule
  ],
  exports: [
    JsonlogicExpressionEditorComponent
  ],
  providers:[BsDatepickerConfig]
})
export class JsonLogicEditorModule { }
